// generated from 36_175 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const xCustomEventPropertyInYDaysGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("x_custom_event_property_in_y_days"),
  // undefined: 36_164 (99.97%), defined 11 (0.03%)
  blocklisted: z.literal(true).optional(),
  comparison_key: z.enum([
    "3", // 22_480 (62.14%)
    "1", // 12_876 (35.59%)
    "5", // 819 (2.26%)
  ]),
  display_name: z.object({
    data: z.array(z.string()),
    id: z.string(),
    // avg: 16.52, min: 1, max: 30
    num_days: z.int().min(1).max(30),
    num_occurrences: z.int().min(0),
    property_name: z.string(),
    // null: 77 (0.21%)
    property_value: z.string().nullable(),
    value: z.string(),
  }),
  // undefined: 19_972 (55.21%), defined 16_203 (44.79%)
  raw_value: z
    .object({
      num_days: z.int().min(1).max(30),
      num_occurrences: z.int().min(0),
      property_name: z.string(),
      // null: 2 (0.01%)
      property_value: z.string().nullable(),
    })
    .optional(),
  value: z.object({
    num_days: z.int().min(1).max(30),
    num_occurrences: z.int().min(0),
    property_name: z.string(),
    // null: 77 (0.21%)
    property_value: z.string().nullable(),
  }),
  varies_by_app_group: z.literal(true),
});
